import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconInfoRed } from "../Images/icon_info_red.svg";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";

const OrderContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const offset = 2;
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");

  const [totalAmount, setTotalAmount] = useState(0);
  const [total_cart, setTotal_cart] = useState(0);
  const [cart_list, setCart_list] = useState([]);
  const lastOrderInfoRequestKey = useRef(null);

  const getOrderInfo = async () => {
    try {
      const body = {
        page,
        offset,
        gifticonCartIdArr: location.state.gifticonCartIdArr,
      };

      const res = await postJson("/dashboard/gifticonOrder/getOrderInfo", body, navigate);
      if (res.code === 200) {
        const data = res.data;
        setTotalAmount(data.totalAmount);
        setTotal_cart(data.count);
        setCart_list(data.rows);
      }
    } catch (error) {
      console.log("주문 리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  const handleOrder = async () => {
    try {
      const body = {
        gifticonCartIdArr: location.state.gifticonCartIdArr,
        transferUsername: name,
        cashNo: number,
        cashEmail: email,
      };

      const res = await postJson("/dashboard/gifticonOrder/transferOrder", body, navigate);
      if (res.code === 200) {
        navigate("/dashboard/gifticon/order/complete", {
          state: {
            paymentId: res.data.paymentId,
          },
        });
      }
    } catch (error) {
      console.error("무통장입금 주문하기 중 에러:", error);
    }
  };

  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const regEmail =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

  const handleEmailBlur = () => {
    if (regEmail.test(email)) {
      setEmailErrorMsg("");
    } else {
      setEmailErrorMsg("올바른 이메일 주소를 입력해주세요.");
    }
  };

  useEffect(() => {
    setIsButtonEnabled(name && number && email && regEmail.test(email));
  }, [name, number, email]);

  useEffect(() => {
    const requestKey = JSON.stringify({
      page,
      gifticonCartIdArr: location.state?.gifticonCartIdArr ?? [],
    });

    if (lastOrderInfoRequestKey.current === requestKey) {
      return;
    }

    lastOrderInfoRequestKey.current = requestKey;
    getOrderInfo();
  }, [page]);

  return (
    <div>
      <PushApplyBox>
        <div className="title-in-box">주문하기</div>

        <div
          className="bold-text"
          style={{ marginTop: "30px", marginBottom: "8px", fontSize: "18px" }}
        >
          주문 상품
        </div>
        <div
          className="list_titleBar"
          style={{
            width: "735px",
            height: "44px",
            gridTemplateColumns: "44px 300px 140px 251px",
          }}
        >
          <div />
          <p
            className="leftalign medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            기프티콘
          </p>
          <p
            className="leftalign medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            주문 수량
          </p>
          <p
            className="leftalign medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            주문 금액
          </p>
        </div>
        {cart_list.slice(0, 2).map((data) => (
          <ListItem
            image={data.goodsImgS}
            name={data.goodsName}
            brand={data.brandName}
            cost={data.totalAmount}
            quantity={data.quantity}
          />
        ))}

        <Pagination
          totalPages={total_cart === 0 ? 1 : Math.ceil(total_cart / 2)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />

        <div
          className="bold-text"
          style={{ marginTop: "40px", fontSize: "18px" }}
        >
          총 결제 금액
        </div>

        <div
          className="medium-text"
          style={{ color: "#222222", marginTop: "14px" }}
        >
          {totalAmount?.toLocaleString()}원
        </div>

        <div
          className="bold-text"
          style={{ marginTop: "40px", fontSize: "18px" }}
        >
          결제 수단
        </div>
        <div style={{ display: "flex", marginTop: "14px" }}>
          <input
            type="radio"
            checked
            style={{ width: "20px", height: "20px" }}
          />
          <div style={{ color: "#222222", marginLeft: "7px" }}>무통장입금</div>
        </div>
        <div
          className="grayBox"
          style={{ marginTop: "14px", padding: "30px 24px" }}
        >
          입금처 : 농협은행 / 301-0327-0214-21 / 주식회사 러닝포인트
        </div>
        <div style={{ color: "#f25c5c", marginTop: "14px" }}>
          *주문 후 72시간 내 미입금시 주문 자동 취소됩니다.
        </div>

        <hr
          color="#e4e4e4"
          style={{
            margin: "30px 0",
            border: 0,
            height: "1px",
          }}
        />

        <div className="medium-text" style={{ color: "#222222" }}>
          입금자명
        </div>
        <div style={{ marginTop: "16px" }}>
          <InputBox
            placeholder="원활한 입금 확인을 위해 정확한 입금자명을 입력해주세요"
            handleValue={(value) => setName(value)}
          />
        </div>
        <div style={{ marginTop: "14px", color: "#f25c5c" }}>
          *입금자명이 실제와 다를 경우 입금확인이 어려울 수 있습니다.
        </div>

        <div
          className="medium-text"
          style={{ color: "#222222", marginTop: "30px" }}
        >
          현금영수증 정보 입력
        </div>

        <div style={{ color: "#222222", marginTop: "16px" }}>사업자번호</div>
        <div style={{ marginTop: "8px" }}>
          <InputBox
            placeholder="사업자번호 10자리를 입력해주세요(‘-’ 제외)"
            handleValue={(value) => setNumber(value)}
          />
        </div>
        <div style={{ color: "#222222", marginTop: "16px" }}>발급 이메일</div>
        <div style={{ marginTop: "8px" }}>
          <InputBox
            placeholder="발급받을 이메일을 입력해주세요"
            handleValue={(value) => setEmail(value)}
            handleBlur={handleEmailBlur}
          />
          {emailErrorMsg && (
            <div style={{ display: "flex", marginTop: "14px" }}>
              <IconInfoRed />
              <p
                style={{
                  color: "#f25c5c",
                  marginLeft: "4px",
                }}
              >
                {emailErrorMsg}
              </p>
            </div>
          )}
        </div>

        <div
          className="blueBtn-base"
          style={{
            width: "280px",
            height: "60px",
            borderRadius: "10px",
            marginTop: "60px",
            justifySelf: "center",
            backgroundColor: isButtonEnabled ? "#1167ed" : "#b0b0b0",
          }}
          onClick={isButtonEnabled ? handleOrder : null}
        >
          주문하기
        </div>
      </PushApplyBox>
    </div>
  );
};

const ListItem = ({ image, name, brand, quantity, cost }) => {
  return (
    <div
      className="list_contentBar"
      style={{
        width: "735px",
        height: "61px",
        gridTemplateColumns: "44px 300px 140px 251px",
      }}
    >
      <div className="center">
        <div style={{ width: "44px", height: "44px" }}>
          <img src={image} style={{ width: "100%", height: "100%" }} />
        </div>
      </div>
      <p className="leftalign">{name}</p>
      <p className="leftalign">{quantity?.toLocaleString()}개</p>
      <p className="leftalign">{cost?.toLocaleString()}원</p>
    </div>
  );
};

const InputBox = ({ placeholder, handleValue, handleBlur = null }) => {
  return (
    <div
      style={{
        padding: "16px 14px",
        boxShadow: "inset 0 0 0 1px #e4e4e4",
        borderRadius: "10px",
      }}
    >
      <input
        type="text"
        className="textinput"
        style={{ width: "703px", height: "21px" }}
        placeholder={placeholder}
        onChange={(e) => handleValue(e.target.value)}
        onBlur={handleBlur}
      />
    </div>
  );
};

const PushApplyBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  margin-left: 413px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #ffffff;
`;

const Order = () => {
  return <Layout page={<OrderContent />} />;
};

export default Order;
